import {
  doctorLogout,
} from '@/api/doctorapi'
import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);

const state = {
  docpcInfo: null, // 医生信息
  docpcForm: null, // 医生信息表单
};

const mutations = {
  setDocpcInfo(state, payload) {
    if (state.docpcInfo === null) {
      state.docpcInfo = payload
    } else {
      Object.assign(state.docpcInfo, payload)
    }
  },
  clearDocpcInfo(state) {
    state.docpcInfo = null
    // doctorLogout({
    //   name: state.docpcInfo.doctor.name,
    //   idsn: state.docpcInfo.doctor.idsn,
    // }).then(res => {
    //   state.docpcInfo = null
    //   console.log('doctorLogout', res, state.docpcInfo)
    //   window.location.reload()
    //   // if (res.data) {
        
    //   // } else {
    //   //   Toast('退出登录失败！')
    //   // }
    // }).catch(err => {
    //   console.log('doctorLogout err', err)
    //   Toast(err.response.data.message)
    // })
  },
  setDocpcForm(state, payload) {
    if (state.docpcForm === null) {
      state.docpcForm = payload
    } else {
      Object.assign(state.docpcForm, payload)
    }
    console.log('setDocpcForm payload', payload, state.docpcForm)
  },
  clearDocpcForm(state) {
    state.docpcForm = null
  },
};

const getters = {
  getDocpcInfo(state) {
    return state.docpcInfo;
  },
  getDocpcForm(state) {
    return state.docpcForm;
  },
}

const actions = {
  SET_DOCPC_INFO(context, payload) {
    context.commit("setDocpcInfo", payload);
  },
  CLEAR_DOCPC_INFO(context) {
    context.commit("clearDocpcInfo");
  },
  SET_DOCPC_FORM(context, payload) {
    context.commit("setDocpcForm", payload);
  },
  CLEAR_DOCPC_FORM(context) {
    context.commit("clearDocpcForm");
  },
};

export default { state, getters, mutations, actions };